import { axios } from "utils";

import { PUBLIC_PRACTICES_URL as endpoint } from "consts";

import {
  PracticeCrop,
  PracticeFertilizerApplication,
  PracticeFertilizerMineral,
  PracticeFertilizerOrganic,
  PracticeLandUseChange,
  PracticePlantProtection,
  PracticeSeeding,
  PracticeSpecification,
  PracticeTillage,
} from "models";

export const getAllPractices = async (): Promise<PracticeSpecification[]> => axios.get(`${endpoint}/`);

export const getPracticeCrops = async ({ enabled, regionId }: { enabled?: boolean; regionId?: string }): Promise<PracticeCrop[]> =>
  axios.get(`${endpoint}/crops`, { params: { enabled, regionId } });

export const getPracticeSeedings = async ({ enabled }: { enabled?: boolean; regionId?: string }): Promise<PracticeSeeding[]> =>
  axios.get(`${endpoint}/seedings`, { params: { enabled } });

export const getPracticeTillages = async ({ enabled }: { enabled?: boolean }): Promise<PracticeTillage[]> =>
  axios.get(`${endpoint}/tillages`, { params: { enabled } });

export const getPracticeMineralFertilizers = async ({ enabled }: { enabled?: boolean }): Promise<PracticeFertilizerMineral[]> =>
  axios.get(`${endpoint}/mineral-fertilizers`, { params: { enabled } });

export const getPracticeOrganicFertilizers = async ({ enabled }: { enabled?: boolean }): Promise<PracticeFertilizerOrganic[]> =>
  axios.get(`${endpoint}/organic-fertilizers`, { params: { enabled } });

export const getPracticeOrganicFertilizerApplications = async ({ enabled }: { enabled?: boolean }): Promise<PracticeFertilizerApplication[]> =>
  axios.get(`${endpoint}/organic-fertilizers/applications`, { params: { enabled } });

export const getPracticePlantProtections = async (): Promise<PracticePlantProtection[]> => axios.get(`${endpoint}/plant-protections`);

export const getPracticeLandUseChanges = async (): Promise<PracticeLandUseChange[]> => axios.get(`${endpoint}/land-use-changes`);
